export interface VideoItem {
  id: number;
  title: string;
  type: "movie" | "tv" | "variety";
  region: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  actors: string[];
  cover: string;
  summary: string;
  description: string;
  updatedAt: string;
  hot: number;
  tags: string[];
}

export const typeLabels: Record<string, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const categoryMeta: Record<
  string,
  { name: string; slogan: string; intro: string }
> = {
  movie: {
    name: "电影",
    slogan: "大银幕的沉浸时刻",
    intro:
      "汇集国产、欧美、日韩等地高分电影，涵盖科幻、悬疑、爱情与动作类型，在线高清观看，随时开启一段两小时的光影旅程。",
  },
  tv: {
    name: "电视剧",
    slogan: "一集接一集停不下来",
    intro:
      "精选都市、古装、悬疑与科幻剧集，全集高清更新，追剧不掉线，让你一次看个够。",
  },
  variety: {
    name: "综艺",
    slogan: "欢乐与陪伴的日常",
    intro:
      "囊括美食、竞技、生活观察类热门综艺，轻松解压，适合全家一起边看边聊。",
  },
};

export const videos: VideoItem[] = [
  {
    id: 1,
    title: "长安幻夜",
    type: "movie",
    region: "国产",
    year: 2025,
    rating: 8.7,
    duration: "136分钟",
    director: "陈牧之",
    actors: ["李慕白", "苏晚晴", "赵川"],
    cover:
      "https://readdy.ai/api/search-image?query=tang%20dynasty%20ancient%20chinese%20city%20at%20night%20with%20lanterns%20and%20mist%2C%20lone%20cloaked%20figure%20walking%20under%20glowing%20lights%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-01&orientation=portrait",
    summary: "盛唐长安一夜之间失去灯火，少年御风人追查幻术谜案。",
    description:
      "长安城的灯火在一夜之间全部熄灭，随之而来的还有一桩离奇的连环失踪案。少年御风人沈砚被卷入其中，他必须与神秘的女画师联手，在幻术与真相交织的长夜里寻找答案。影片用极具东方美学的镜头语言，构建了一个亦真亦幻的盛唐世界，群像刻画细腻，悬疑氛围层层递进。",
    updatedAt: "2025-09-28",
    hot: 9820,
    tags: ["古装", "悬疑", "奇幻"],
  },
  {
    id: 2,
    title: "深海迷航",
    type: "movie",
    region: "欧美",
    year: 2024,
    rating: 8.2,
    duration: "128分钟",
    director: "Alan Reyes",
    actors: ["Marcus Cole", "Elena Frost", "David Kane"],
    cover:
      "https://readdy.ai/api/search-image?query=lone%20submarine%20diving%20into%20deep%20dark%20ocean%20trench%20with%20bioluminescent%20glow%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-02&orientation=portrait",
    summary: "一支科考队深入海沟，却发现深海之下藏着更危险的秘密。",
    description:
      "一支国际科考队驾驶深海探测器进入从未被探索过的海沟，原本的科研任务很快演变为一场求生之旅。未知的生物、失灵的通讯与逐渐崩溃的信任，让每个人都被迫直面内心的恐惧。影片以压迫感十足的视听语言，带来一场窒息级的深海冒险。",
    updatedAt: "2025-09-21",
    hot: 8640,
    tags: ["科幻", "冒险", "惊悚"],
  },
  {
    id: 3,
    title: "都市摆渡人",
    type: "tv",
    region: "国产",
    year: 2025,
    rating: 8.9,
    duration: "45分钟/集 · 全36集",
    director: "周牧云",
    actors: ["林知远", "沈清夏", "顾亦寒"],
    cover:
      "https://readdy.ai/api/search-image?query=rainy%20modern%20metropolitan%20cityscape%20at%20night%20with%20neon%20reflections%20and%20a%20solitary%20figure%20holding%20umbrella%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-03&orientation=portrait",
    summary: "深夜电台主播用声音，为城市里每一个失眠的陌生人摆渡。",
    description:
      "凌晨三点的城市，有一档名为《摆渡》的深夜电台。主播林知远用温和的声音接住一个个陌生人来电背后的故事，也在不知不觉间治愈着自己。剧集以单元故事串联，节奏舒缓却有力量，写尽了都市人之间微小而真诚的连接。",
    updatedAt: "2025-09-30",
    hot: 10460,
    tags: ["都市", "治愈", "群像"],
  },
  {
    id: 4,
    title: "星河物语",
    type: "tv",
    region: "日韩",
    year: 2024,
    rating: 8.5,
    duration: "42分钟/集 · 全24集",
    director: "佐藤律",
    actors: ["白石遥", "金田优", "辛秀雅"],
    cover:
      "https://readdy.ai/api/search-image?query=young%20couple%20standing%20beneath%20a%20vast%20starry%20galaxy%20sky%20on%20a%20grassy%20hill%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-04&orientation=portrait",
    summary: "两个天文社少年，用一整个夏天丈量银河与青春的距离。",
    description:
      "小镇高中的天文社只剩两名成员，他们决定在暑假完成一台自制望远镜，去寻找传说中一年只出现一次的行星。整个夏天，他们看星星、聊未来，也慢慢靠近彼此。清新的画面与细腻的情感，让这段青春记忆温柔而克制。",
    updatedAt: "2025-09-17",
    hot: 7210,
    tags: ["青春", "爱情", "治愈"],
  },
  {
    id: 5,
    title: "欢乐大玩家",
    type: "variety",
    region: "国产",
    year: 2025,
    rating: 8.1,
    duration: "约90分钟/期 · 更新至08期",
    director: "陈可",
    actors: ["何旭", "杨帆", "林小雨"],
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20colorful%20game%20show%20stage%20with%20confetti%20and%20spotlights%2C%20cheerful%20energy%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-05&orientation=portrait",
    summary: "全明星阵容化身玩家，在城市里完成一场又一场爆笑挑战。",
    description:
      "节目邀请六位常驻嘉宾组成玩家联盟，每期围绕一座城市展开不同主题的闯关挑战。没有剧本，全靠临场反应与默契，笑点密集又充满烟火气，是解压放松的首选综艺。",
    updatedAt: "2025-10-01",
    hot: 9120,
    tags: ["真人秀", "竞技", "爆笑"],
  },
  {
    id: 6,
    title: "山海奇缘",
    type: "tv",
    region: "国产",
    year: 2025,
    rating: 8.6,
    duration: "46分钟/集 · 全30集",
    director: "苏昊",
    actors: ["江晏", "温以宁", "陆沉"],
    cover:
      "https://readdy.ai/api/search-image?query=majestic%20ancient%20mountain%20and%20sea%20landscape%20with%20mythical%20mist%20and%20distant%20flying%20creatures%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-06&orientation=portrait",
    summary: "少年循着山海残卷寻访异兽，踏上修复天地秩序的旅途。",
    description:
      "上古山海残卷散落人间，天地秩序日渐失稳。少年阿黎偶然拾得残卷一角，从此踏上寻访异兽、修补结界的旅途。剧集视效绚丽，世界观宏大，既有热血成长，也有关于取舍与守护的思考。",
    updatedAt: "2025-09-25",
    hot: 8890,
    tags: ["奇幻", "古装", "冒险"],
  },
  {
    id: 7,
    title: "追风少年",
    type: "movie",
    region: "国产",
    year: 2024,
    rating: 7.9,
    duration: "112分钟",
    director: "高野",
    actors: ["许嘉树", "何暖", "王锦"],
    cover:
      "https://readdy.ai/api/search-image?query=teenage%20cyclist%20racing%20along%20a%20coastal%20road%20at%20golden%20hour%20with%20wind%20and%20motion%20blur%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-07&orientation=portrait",
    summary: "被退队的自行车手，在小镇重新找到了骑行的意义。",
    description:
      "天才自行车手阿树因伤被省队退训，回到海边小镇后一度消沉。在旧教练与一群业余车友的带动下，他重新跨上自行车，并在一场民间耐力赛中找回了最初的热爱。影片热血而不悬浮，充满海风与少年的味道。",
    updatedAt: "2025-09-12",
    hot: 6540,
    tags: ["青春", "运动", "励志"],
  },
  {
    id: 8,
    title: "午夜信号",
    type: "movie",
    region: "欧美",
    year: 2025,
    rating: 8.4,
    duration: "118分钟",
    director: "Nora Bennett",
    actors: ["James Wilder", "Sofia Marsh", "Leo Grant"],
    cover:
      "https://readdy.ai/api/search-image?query=abandoned%20radio%20station%20in%20a%20foggy%20forest%20at%20midnight%20with%20glowing%20equipment%20and%20lone%20operator%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-08&orientation=portrait",
    summary: "一名无线电爱好者，在午夜收到了一段来自「未来」的求救。",
    description:
      "独自居住在森林边的无线电爱好者 Owen，某天深夜截获了一段无法解释的信号。信号里有人在求救，而对方报出的日期，竟是三天之后。随着新的信号不断出现，Owen 发现真相远比想象中更接近自己。一部节奏紧凑、结尾让人回味的小成本悬疑佳作。",
    updatedAt: "2025-09-27",
    hot: 8330,
    tags: ["悬疑", "科幻", "惊悚"],
  },
  {
    id: 9,
    title: "厨房大作战",
    type: "variety",
    region: "国产",
    year: 2024,
    rating: 7.6,
    duration: "约75分钟/期 · 全12期",
    director: "白露",
    actors: ["孙可", "孟晨", "钱多多"],
    cover:
      "https://readdy.ai/api/search-image?query=busy%20professional%20kitchen%20with%20chefs%20cooking%20and%20colorful%20fresh%20ingredients%2C%20warm%20inviting%20atmosphere%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-09&orientation=portrait",
    summary: "素人厨神与明星嘉宾同台，限时完成指定主题菜品。",
    description:
      "每期邀请不同背景的素人厨艺高手与明星嘉宾组队，在限定时间内完成指定主题的菜品。评审从创意、口味与完成度打分，既有紧张的赛制，也有厨房里的温情故事，看得人食欲与热血齐飞。",
    updatedAt: "2025-09-08",
    hot: 5820,
    tags: ["美食", "竞技", "生活"],
  },
  {
    id: 10,
    title: "雾都疑云",
    type: "tv",
    region: "欧美",
    year: 2024,
    rating: 8.8,
    duration: "50分钟/集 · 全20集",
    director: "Oliver Hayes",
    actors: ["Harriet Voss", "Colin Reed", "Amara Diaz"],
    cover:
      "https://readdy.ai/api/search-image?query=foggy%20victorian%20london%20street%20with%20gas%20lamps%20and%20a%20detective%20silhouette%20in%20a%20long%20coat%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-10&orientation=portrait",
    summary: "资深探长与法医搭档，在浓雾笼罩的都市里追查连环谜案。",
    description:
      "浓雾常年不散的都市里，接连发生手法相似的离奇案件。资深探长与冷静的年轻法医组成搭档，从细节中抽丝剥茧。剧集逻辑严密、氛围阴郁而高级，每一集都留有一处让人拍案的反转。",
    updatedAt: "2025-09-19",
    hot: 9760,
    tags: ["悬疑", "犯罪", "推理"],
  },
  {
    id: 11,
    title: "樱色流年",
    type: "tv",
    region: "日韩",
    year: 2025,
    rating: 8.3,
    duration: "44分钟/集 · 全16集",
    director: "森川南",
    actors: ["青木结衣", "金城武藏", "尹世拉"],
    cover:
      "https://readdy.ai/api/search-image?query=path%20lined%20with%20blooming%20cherry%20blossom%20trees%20and%20a%20solitary%20walking%20girl%20in%20soft%20pink%20light%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-11&orientation=portrait",
    summary: "一封迟到十年的信，让两个故人重逢在樱花落尽的春天。",
    description:
      "整理旧物时，千夏发现了一封写给自己的信，落款是十年前的初恋。她回到故乡，希望找到写信的人，也重新面对当年那段不告而别的青春。剧集画面唯美，情感克制而饱满，是关于时间与和解的温柔叙事。",
    updatedAt: "2025-09-23",
    hot: 6980,
    tags: ["爱情", "治愈", "都市"],
  },
  {
    id: 12,
    title: "龙城风云",
    type: "movie",
    region: "港台",
    year: 2024,
    rating: 8.0,
    duration: "124分钟",
    director: "郑建国",
    actors: ["黄志烈", "吴家豪", "陈美玲"],
    cover:
      "https://readdy.ai/api/search-image?query=neon%20lit%20hong%20kong%20harbor%20skyline%20at%20night%20with%20two%20figures%20facing%20off%20on%20a%20rooftop%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-12&orientation=portrait",
    summary: "一名卧底警察在黑白之间挣扎，守护城市最后的秩序。",
    description:
      "潜伏多年的卧底警察在一次行动中身份濒临暴露，他必须在兄弟情义与职责之间做出抉择。影片延续了经典港式警匪片的凌厉节奏，动作场面干脆利落，人物塑造有血有肉。",
    updatedAt: "2025-09-14",
    hot: 7740,
    tags: ["动作", "犯罪", "警匪"],
  },
  {
    id: 13,
    title: "宇宙边缘",
    type: "movie",
    region: "欧美",
    year: 2023,
    rating: 8.9,
    duration: "142分钟",
    director: "Christopher Lang",
    actors: ["Daniel Reeves", "Mia Castillo", "Owen Blake"],
    cover:
      "https://readdy.ai/api/search-image?query=lone%20astronaut%20floating%20at%20the%20edge%20of%20a%20vast%20colorful%20nebula%20with%20distant%20planet%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-13&orientation=portrait",
    summary: "人类首次飞出银河系边缘，却发现了不该发现的东西。",
    description:
      "为了寻找新的宜居星球，人类派出了史上最远的载人远征。当飞船抵达银河系边缘，船员们发现那里的物理规律似乎并不适用。影片以宏大视效探讨了孤独、信仰与人类在宇宙中的位置，被誉为近年最震撼的硬核科幻之一。",
    updatedAt: "2025-08-30",
    hot: 11240,
    tags: ["科幻", "太空", "剧情"],
  },
  {
    id: 14,
    title: "家的味道",
    type: "variety",
    region: "国产",
    year: 2025,
    rating: 7.8,
    duration: "约60分钟/期 · 更新至10期",
    director: "许南",
    actors: ["梁静", "徐海", "唐诗"],
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20warm%20family%20dining%20table%20filled%20with%20homecooked%20chinese%20dishes%20and%20soft%20window%20light%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-14&orientation=portrait",
    summary: "每期走进一个家庭，用一顿饭讲述属于他们的故事。",
    description:
      "节目每期探访一个普通家庭，由嘉宾跟着主人一起买菜、下厨，复原一道对全家人意义非凡的家常菜。饭菜之外，镜头记录下的是亲情、乡愁与岁月。平淡却极有力量，适合一个人安静地看。",
    updatedAt: "2025-09-29",
    hot: 5460,
    tags: ["生活", "纪实", "温情"],
  },
  {
    id: 15,
    title: "朝云暮雨",
    type: "movie",
    region: "国产",
    year: 2025,
    rating: 8.5,
    duration: "126分钟",
    director: "沈知白",
    actors: ["周雨棠", "江舟", "林晚"],
    cover:
      "https://readdy.ai/api/search-image?query=young%20woman%20standing%20on%20a%20misty%20mountain%20viewpoint%20at%20sunrise%20with%20dramatic%20clouds%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-15&orientation=portrait",
    summary: "一场意外的相遇，让两个孤独的人在山城共度了一个雨季。",
    description:
      "因工作受挫而回到山城老家的雨棠，遇见了在当地经营旧书店的江舟。两个看似毫无交集的人，因为一场大雨走到了一起。电影用四季流转的镜头，讲述了一段安静、克制却后劲十足的情感。",
    updatedAt: "2025-09-26",
    hot: 8120,
    tags: ["爱情", "文艺", "剧情"],
  },
  {
    id: 16,
    title: "赛博纪元",
    type: "tv",
    region: "欧美",
    year: 2025,
    rating: 8.7,
    duration: "52分钟/集 · 全10集",
    director: "Iris Nakamura",
    actors: ["Kai Mercer", "Lena Ortiz", "Sam Okafor"],
    cover:
      "https://readdy.ai/api/search-image?query=cyberpunk%20city%20with%20glowing%20holographic%20signs%20and%20a%20hacker%20figure%20in%20neon%20rain%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-16&orientation=portrait",
    summary: "在意识可以被上传的时代，一名黑客发现自己的记忆是伪造的。",
    description:
      "在不远的未来，人类意识可以被数字化存储与交易。顶尖黑客凯在追踪一笔异常数据时，发现自己的记忆并不属于自己。为了找回真实身份，他一步步揭开笼罩整座城市的巨大谎言。霓虹美学与反乌托邦内核的结合，视觉与思辨兼具。",
    updatedAt: "2025-10-02",
    hot: 9310,
    tags: ["科幻", "悬疑", "赛博朋克"],
  },
  {
    id: 17,
    title: "少年歌行录",
    type: "tv",
    region: "国产",
    year: 2024,
    rating: 8.2,
    duration: "45分钟/集 · 全40集",
    director: "姜原",
    actors: ["谢云舟", "白小棠", "萧无尘"],
    cover:
      "https://readdy.ai/api/search-image?query=young%20swordsman%20standing%20on%20snowy%20mountain%20peak%20with%20flowing%20robe%20and%20ancient%20sword%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-17&orientation=portrait",
    summary: "山村少年带着一把旧剑，闯入江湖寻找自己的身世。",
    description:
      "在山村长大的无名少年，因一把来历不明的旧剑被卷入江湖纷争。他一路结识挚友、历经生死，也逐渐揭开了自己身世的秘密。剧集打斗设计飘逸，群像鲜活，是一部长篇武侠成长故事。",
    updatedAt: "2025-09-10",
    hot: 7960,
    tags: ["武侠", "古装", "成长"],
  },
  {
    id: 18,
    title: "极限挑战赛",
    type: "variety",
    region: "日韩",
    year: 2025,
    rating: 7.9,
    duration: "约80分钟/期 · 更新至09期",
    director: "金泰勋",
    actors: ["朴宰浩", "李瑞妍", "郑宇成"],
    cover:
      "https://readdy.ai/api/search-image?query=extreme%20outdoor%20obstacle%20course%20with%20athletes%20competing%20in%20dramatic%20lighting%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-18&orientation=portrait",
    summary: "素人选手挑战极限体能，在巨型障碍赛道上争夺冠军。",
    description:
      "节目打造了规模空前的户外障碍赛道，来自各行各业的素人选手需要凭借体能、技巧与意志力完成挑战。赛制残酷但充满热血，选手的真实反应与拼搏瞬间，是本节目最大的魅力所在。",
    updatedAt: "2025-09-24",
    hot: 6240,
    tags: ["竞技", "运动", "热血"],
  },
  {
    id: 19,
    title: "光影之城",
    type: "movie",
    region: "国产",
    year: 2024,
    rating: 8.1,
    duration: "119分钟",
    director: "柳无岸",
    actors: ["贺兰", "程星", "苏禾"],
    cover:
      "https://readdy.ai/api/search-image?query=old%20cinema%20house%20interior%20with%20projector%20light%20beams%20and%20empty%20red%20seats%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-19&orientation=portrait",
    summary: "一家即将关门的老影院，藏着一座城市三代人的记忆。",
    description:
      "老城区最后一家电影院面临拆除，年轻的放映员决定在关门前办一场纪念影展。随着一部部老片重现银幕，一段段属于这座城市的往事也被重新讲述。影片充满对电影本身的热爱，温暖而怀旧。",
    updatedAt: "2025-09-05",
    hot: 6480,
    tags: ["剧情", "温情", "文艺"],
  },
  {
    id: 20,
    title: "江南烟雨",
    type: "tv",
    region: "国产",
    year: 2025,
    rating: 8.4,
    duration: "45分钟/集 · 全28集",
    director: "顾南亭",
    actors: ["沈砚秋", "柳如烟", "谢听澜"],
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20jiangnan%20water%20town%20with%20stone%20bridge%20and%20rain%20ripples%20and%20a%20figure%20in%20flowing%20hanfu%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-20&orientation=portrait",
    summary: "徽商之女执掌家业，在风雨飘摇的年代守护一方基业。",
    description:
      "出身徽商世家的沈砚秋在父兄相继离世后，被迫接手家族生意。她凭借过人的胆识与见识，在动荡年代中守住产业，也守住了心中的道义。剧集服化道考究，商战与情感线交织，古典韵味十足。",
    updatedAt: "2025-09-22",
    hot: 8420,
    tags: ["古装", "传奇", "家国"],
  },
  {
    id: 21,
    title: "荒野求生记",
    type: "variety",
    region: "欧美",
    year: 2024,
    rating: 7.7,
    duration: "约55分钟/期 · 全10期",
    director: "Ben Carter",
    actors: ["Jack Norris", "Hana Lee", "Rui Costa"],
    cover:
      "https://readdy.ai/api/search-image?query=lone%20survivalist%20building%20shelter%20in%20a%20wild%20forest%20at%20dusk%20with%20campfire%20smoke%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-21&orientation=portrait",
    summary: "三名素人被投放到无人荒野，仅凭有限工具生存七天。",
    description:
      "每季把几位普通参与者送到偏远荒野，只提供极少的工具与饮用水，考验他们的生存智慧与团队协作。节目既有硬核的求生技巧展示，也有真实的人性观察，紧张感十足。",
    updatedAt: "2025-09-16",
    hot: 5680,
    tags: ["纪实", "冒险", "生存"],
  },
  {
    id: 22,
    title: "时间旅人",
    type: "movie",
    region: "日韩",
    year: 2025,
    rating: 8.6,
    duration: "133分钟",
    director: "南野拓",
    actors: ["高桥凉", "金秀贤", "郑有美"],
    cover:
      "https://readdy.ai/api/search-image?query=man%20standing%20before%20a%20giant%20glowing%20clock%20portal%20with%20distorted%20city%20behind%20him%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-22&orientation=portrait",
    summary: "他能回到过去一分钟，却始终无法改变最重要那一刻。",
    description:
      "男主意外获得了回到过去一分钟的能力，他以为可以借此弥补所有遗憾，却发现最关键的时刻无论如何都无法改写。一次次尝试之后，他逐渐明白：真正要面对的，是此刻的自己。影片在科幻设定下包裹着极强的情感内核。",
    updatedAt: "2025-09-20",
    hot: 9060,
    tags: ["科幻", "爱情", "剧情"],
  },
  {
    id: 23,
    title: "武林外传新篇",
    type: "tv",
    region: "国产",
    year: 2025,
    rating: 8.0,
    duration: "40分钟/集 · 全24集",
    director: "尚敬川",
    actors: ["佟湘玉", "白展堂", "郭芙蓉"],
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20inn%20courtyard%20at%20night%20with%20warm%20lanterns%20and%20quirky%20colorful%20characters%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-23&orientation=portrait",
    summary: "那家熟悉的客栈重新开张，老朋友们带来了新故事。",
    description:
      "经典客栈的故事翻开新的一页，熟悉的掌柜与伙计们依旧在江湖边的小店里迎来送往。新篇延续了轻松幽默的群像喜剧风格，用一个个小故事调侃生活百态，笑声中藏着温情。",
    updatedAt: "2025-09-18",
    hot: 8740,
    tags: ["喜剧", "古装", "群像"],
  },
  {
    id: 24,
    title: "午夜歌剧院",
    type: "movie",
    region: "欧美",
    year: 2025,
    rating: 8.3,
    duration: "127分钟",
    director: "Camille Laurent",
    actors: ["Isabelle Moreau", "Victor Hale", "Nadia Rossi"],
    cover:
      "https://readdy.ai/api/search-image?query=grand%20opera%20house%20stage%20at%20night%20with%20red%20velvet%20curtains%20and%20a%20singer%20under%20a%20spotlight%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20clean%20uncluttered%20background%2C%20professional%20film%20poster%20composition&width=480&height=720&seq=cover-24&orientation=portrait",
    summary: "一位年轻歌手卷入歌剧院里的古老谜团与未解命案。",
    description:
      "年轻的女高音在一次演出后意外卷入歌剧院尘封多年的谜团。随着排练的深入，她发现舞台上的角色与现实中的众人正一一对应。影片将歌剧元素与惊悚叙事完美融合，视听体验华丽而诡谲。",
    updatedAt: "2025-09-13",
    hot: 7620,
    tags: ["惊悚", "音乐", "剧情"],
  },
];

export interface HeroBanner {
  id: number;
  videoId: number;
  title: string;
  tagline: string;
  meta: string;
  image: string;
}

export const heroBanners: HeroBanner[] = [
  {
    id: 1,
    videoId: 13,
    title: "宇宙边缘",
    tagline: "人类首次飞出银河系边缘，却发现了不该发现的东西。",
    meta: "电影 · 科幻 · 豆瓣 8.9",
    image:
      "https://readdy.ai/api/search-image?query=lone%20astronaut%20floating%20before%20a%20colossal%20swirling%20nebula%20with%20deep%20crimson%20and%20teal%20light%2C%20epic%20sci-fi%20cinematic%20key%20art%2C%20dramatic%20backlighting%2C%20atmospheric%20haze%2C%20dark%20dramatic%20sky%2C%20ultra%20detailed%2C%20high%20contrast%2C%20professional%20film%20banner%20composition&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
  {
    id: 2,
    videoId: 3,
    title: "都市摆渡人",
    tagline: "深夜电台用声音，为城市里每一个失眠的陌生人摆渡。",
    meta: "电视剧 · 都市治愈 · 豆瓣 8.9",
    image:
      "https://readdy.ai/api/search-image?query=rainy%20modern%20city%20skyline%20at%20night%20with%20neon%20reflections%20on%20wet%20streets%20and%20distant%20lone%20figure%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20high%20contrast%2C%20professional%20film%20banner%20composition&width=1600&height=900&seq=hero-02&orientation=landscape",
  },
  {
    id: 3,
    videoId: 16,
    title: "赛博纪元",
    tagline: "在意识可以被上传的时代，一名黑客发现自己的记忆是伪造的。",
    meta: "电视剧 · 科幻悬疑 · 豆瓣 8.7",
    image:
      "https://readdy.ai/api/search-image?query=cyberpunk%20metropolis%20with%20towering%20holographic%20signs%20and%20neon%20rain%20and%20a%20lone%20hacker%20silhouette%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20ultra%20detailed%2C%20high%20contrast%2C%20professional%20film%20banner%20composition&width=1600&height=900&seq=hero-03&orientation=landscape",
  },
  {
    id: 4,
    videoId: 10,
    title: "雾都疑云",
    tagline: "资深探长与法医搭档，在浓雾笼罩的都市里追查连环谜案。",
    meta: "电视剧 · 悬疑推理 · 豆瓣 8.8",
    image:
      "https://readdy.ai/api/search-image?query=foggy%20victorian%20city%20street%20at%20night%20with%20gas%20lamps%2C%20a%20detective%20silhouette%20walking%20away%2C%20dense%20atmospheric%20fog%2C%20cinematic%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20crimson%20and%20teal%20color%20grading%2C%20ultra%20detailed%2C%20high%20contrast%2C%20professional%20film%20banner%20composition&width=1600&height=900&seq=hero-04&orientation=landscape",
  },
];

export const regions = ["全部", "国产", "欧美", "日韩", "港台"];
export const years = ["全部", "2025", "2024", "2023"];
export const sortOptions = [
  { key: "hot", label: "按热度" },
  { key: "new", label: "按新片" },
  { key: "rating", label: "按评分" },
];